import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ReactionThumbsDownIcon = (props: IconProps) => (
  <Icon width="32px" height="32px" viewBox="0 0 32 32" {...props}>
    <circle cx="16" cy="16" r="16" fill="#E5F2FF" />
    <path
      fill="#007AFF"
      d="M18.667 8.666h-8c-.738 0-1.37.444-1.636 1.084l-2.684 6.267c-.08.205-.125.418-.125.649v1.778c0 .978.8 1.778 1.778 1.778h5.609l-.845 4.062-.026.284c0 .365.15.702.39.942l.943.934 5.858-5.858c.32-.32.515-.764.515-1.253v-8.89c0-.977-.8-1.777-1.777-1.777Zm3.555 0v10.667h3.556V8.666h-3.556Z"
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M5.333 6h21.333v21.333H5.333z" />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(ReactionThumbsDownIcon);
